// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeAccountApi = class EdgeAccountApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param IActivateUserRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountActivateUser(IActivateUserRequestModel, x_program_id) {
        const _url_ = '/edge/account/ActivateUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IActivateUserRequestModel' is not null or undefined
        if (IActivateUserRequestModel === null || IActivateUserRequestModel === undefined) {
            throw new Error('Required parameter IActivateUserRequestModel was null or undefined when calling accountActivateUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IActivateUserRequestModel, "IActivateUserRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountActivateUserDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountGetPrescribers(body, x_program_id) {
        const _url_ = '/edge/account/GetPrescribers';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling accountGetPrescribers.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountGetPrescribersDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountGetSites(body, x_program_id) {
        const _url_ = '/edge/account/GetSites';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling accountGetSites.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountGetSitesDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param IGetTasksRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountGetTasks(IGetTasksRequestModel, x_program_id) {
        const _url_ = '/edge/account/GetTasks';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IGetTasksRequestModel' is not null or undefined
        if (IGetTasksRequestModel === null || IGetTasksRequestModel === undefined) {
            throw new Error('Required parameter IGetTasksRequestModel was null or undefined when calling accountGetTasks.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IGetTasksRequestModel, "IGetTasksRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountGetTasksDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountGetUsers(body, x_program_id) {
        const _url_ = '/edge/account/GetUsers';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling accountGetUsers.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountGetUsersDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param RemovePrescriberRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountRemovePrescriber(RemovePrescriberRequestModel, x_program_id) {
        const _url_ = '/edge/account/RemovePrescriber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'RemovePrescriberRequestModel' is not null or undefined
        if (RemovePrescriberRequestModel === null || RemovePrescriberRequestModel === undefined) {
            throw new Error('Required parameter RemovePrescriberRequestModel was null or undefined when calling accountRemovePrescriber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(RemovePrescriberRequestModel, "RemovePrescriberRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountRemovePrescriberDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param RemoveSiteRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountRemoveSite(RemoveSiteRequestModel, x_program_id) {
        const _url_ = '/edge/account/RemoveSite';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'RemoveSiteRequestModel' is not null or undefined
        if (RemoveSiteRequestModel === null || RemoveSiteRequestModel === undefined) {
            throw new Error('Required parameter RemoveSiteRequestModel was null or undefined when calling accountRemoveSite.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(RemoveSiteRequestModel, "RemoveSiteRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountRemoveSiteDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param PrescriberUpsearchModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountSavePrescriber(PrescriberUpsearchModel, x_program_id) {
        const _url_ = '/edge/account/SavePrescriber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PrescriberUpsearchModel' is not null or undefined
        if (PrescriberUpsearchModel === null || PrescriberUpsearchModel === undefined) {
            throw new Error('Required parameter PrescriberUpsearchModel was null or undefined when calling accountSavePrescriber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PrescriberUpsearchModel, "PrescriberUpsearchModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountSavePrescriberDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SiteUpsearchModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountSaveSite(SiteUpsearchModel, x_program_id) {
        const _url_ = '/edge/account/SaveSite';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SiteUpsearchModel' is not null or undefined
        if (SiteUpsearchModel === null || SiteUpsearchModel === undefined) {
            throw new Error('Required parameter SiteUpsearchModel was null or undefined when calling accountSaveSite.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SiteUpsearchModel, "SiteUpsearchModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountSaveSiteDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param NoteTaskCreateModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountSaveTask(NoteTaskCreateModel, x_program_id) {
        const _url_ = '/edge/account/SaveTask';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'NoteTaskCreateModel' is not null or undefined
        if (NoteTaskCreateModel === null || NoteTaskCreateModel === undefined) {
            throw new Error('Required parameter NoteTaskCreateModel was null or undefined when calling accountSaveTask.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(NoteTaskCreateModel, "NoteTaskCreateModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountSaveTaskDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param ScriptsAccountSaveUserSaveUserRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountSaveUser(ScriptsAccountSaveUserSaveUserRequestModel, x_program_id) {
        const _url_ = '/edge/account/SaveUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ScriptsAccountSaveUserSaveUserRequestModel' is not null or undefined
        if (ScriptsAccountSaveUserSaveUserRequestModel === null || ScriptsAccountSaveUserSaveUserRequestModel === undefined) {
            throw new Error('Required parameter ScriptsAccountSaveUserSaveUserRequestModel was null or undefined when calling accountSaveUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ScriptsAccountSaveUserSaveUserRequestModel, "ScriptsAccountSaveUserSaveUserRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountSaveUserDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param ISaveUserRoleRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountSaveUserRole(ISaveUserRoleRequestModel, x_program_id) {
        const _url_ = '/edge/account/SaveUserRole';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ISaveUserRoleRequestModel' is not null or undefined
        if (ISaveUserRoleRequestModel === null || ISaveUserRoleRequestModel === undefined) {
            throw new Error('Required parameter ISaveUserRoleRequestModel was null or undefined when calling accountSaveUserRole.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ISaveUserRoleRequestModel, "ISaveUserRoleRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountSaveUserRoleDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param AccountSaveModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountUpdateAccount(AccountSaveModel, x_program_id) {
        const _url_ = '/edge/account/UpdateAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'AccountSaveModel' is not null or undefined
        if (AccountSaveModel === null || AccountSaveModel === undefined) {
            throw new Error('Required parameter AccountSaveModel was null or undefined when calling accountUpdateAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(AccountSaveModel, "AccountSaveModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountUpdateAccountDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SaveThirdPartyIdRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async externalIdSaveThirdPartyId(SaveThirdPartyIdRequestModel, x_program_id) {
        const _url_ = '/edge/account/ExternalId/saveThirdPartyId';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SaveThirdPartyIdRequestModel' is not null or undefined
        if (SaveThirdPartyIdRequestModel === null || SaveThirdPartyIdRequestModel === undefined) {
            throw new Error('Required parameter SaveThirdPartyIdRequestModel was null or undefined when calling externalIdSaveThirdPartyId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SaveThirdPartyIdRequestModel, "SaveThirdPartyIdRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountExternalIdSaveThirdPartyIdSaveThirdPartyIdResponse");
        }
        return response;
    }
    /**
     *
     * @param PrescribersRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async prescribersHubGetPrescribers(PrescribersRequestModel, x_program_id) {
        const _url_ = '/edge/account/v2/Prescribers/HubGetPrescribers';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PrescribersRequestModel' is not null or undefined
        if (PrescribersRequestModel === null || PrescribersRequestModel === undefined) {
            throw new Error('Required parameter PrescribersRequestModel was null or undefined when calling prescribersHubGetPrescribers.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PrescribersRequestModel, "PrescribersRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountV2PrescribersHubGetPrescribersHubGetPrescribersResponse");
        }
        return response;
    }
    /**
     *
     * @param SiteRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async sitesHubGetSites(SiteRequestModel, x_program_id) {
        const _url_ = '/edge/account/v2/Sites/HubGetSites';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SiteRequestModel' is not null or undefined
        if (SiteRequestModel === null || SiteRequestModel === undefined) {
            throw new Error('Required parameter SiteRequestModel was null or undefined when calling sitesHubGetSites.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SiteRequestModel, "SiteRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountV2SitesHubGetSitesHubGetSitesResponse");
        }
        return response;
    }
};
EdgeAccountApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeAccountApi);
export { EdgeAccountApi };
//# sourceMappingURL=edgeAccountApi.js.map